
import React, { useEffect } from "react";
import MainLayout from "@/layout/MainLayout";
import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { HowItWorks } from "@/components/HowItWorks";
import { CallToAction } from "@/components/CallToAction";

const Index = () => {
  return (
    <MainLayout>
      <Hero />
      <Features />
      <HowItWorks />
      <CallToAction />
    </MainLayout>
  );
};

export default Index;
